import { computed } from "@ember/object";
import { and, reads } from "@ember/object/computed";
import { classNames } from "@ember-decorators/component";
import DButton from "discourse/components/d-button";
import icon from "discourse/helpers/d-icon";
import { resolveComponent } from "select-kit/components/select-kit";
import SingleSelectHeaderComponent from "select-kit/components/select-kit/single-select-header";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const ComboBoxHeader = dt7948.c(class ComboBoxHeader extends SingleSelectHeaderComponent {
  static {
    dt7948.g(this.prototype, "clearable", [reads("selectKit.options.clearable")]);
  }
  #clearable = (dt7948.i(this, "clearable"), void 0);
  static {
    dt7948.g(this.prototype, "caretUpIcon", [reads("selectKit.options.caretUpIcon")]);
  }
  #caretUpIcon = (dt7948.i(this, "caretUpIcon"), void 0);
  static {
    dt7948.g(this.prototype, "caretDownIcon", [reads("selectKit.options.caretDownIcon")]);
  }
  #caretDownIcon = (dt7948.i(this, "caretDownIcon"), void 0);
  static {
    dt7948.g(this.prototype, "shouldDisplayClearableButton", [and("clearable", "value")]);
  }
  #shouldDisplayClearableButton = (dt7948.i(this, "shouldDisplayClearableButton"), void 0);
  get caretIcon() {
    return this.selectKit.isExpanded ? this.caretUpIcon : this.caretDownIcon;
  }
  static {
    dt7948.n(this.prototype, "caretIcon", [computed("selectKit.isExpanded", "caretUpIcon", "caretDownIcon")]);
  }
  static {
    setComponentTemplate(precompileTemplate("\n    <div class=\"select-kit-header-wrapper\">\n      {{#each this.icons as |iconName|}} {{icon iconName}} {{/each}}\n\n      {{#let (resolveComponent this this.selectKit.options.selectedNameComponent) as |SelectedNameComponent|}}\n        <SelectedNameComponent @tabindex={{this.tabindex}} @item={{this.selectedContent}} @selectKit={{this.selectKit}} />\n      {{/let}}\n\n      {{#if this.shouldDisplayClearableButton}}\n        <DButton @icon=\"xmark\" @action={{this.selectKit.onClearSelection}} @ariaLabel=\"clear_input\" class=\"btn-clear\" />\n      {{/if}}\n\n      {{icon this.caretIcon class=\"caret-icon\"}}\n    </div>\n  ", {
      strictMode: true,
      scope: () => ({
        icon,
        resolveComponent,
        DButton
      })
    }), this);
  }
}, [classNames("combo-box-header")]);
export default ComboBoxHeader;